import { render, staticRenderFns } from "./SaveInDraftsPopup.vue?vue&type=template&id=6e57d31d"
import script from "./SaveInDraftsPopup.vue?vue&type=script&lang=js"
export * from "./SaveInDraftsPopup.vue?vue&type=script&lang=js"
import style0 from "./SaveInDraftsPopup.vue?vue&type=style&index=0&id=6e57d31d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports